import axios, { AxiosInstance } from 'axios';
import { accessToken } from '../utils/auth';

// Create an Axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: `${import.meta.env.REACT_APP_BACKEND_URL}/api/v1`,
  timeout: 10000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  async config => {
    const token = await accessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default apiClient;
